module.exports = __webpack_public_path__ + "img/favicon.792bbff3.ico";